import { getQtyForMultipack } from "../../../../../aem-components/product-details/utils";
const fallbackSticksImages = (placeholderImage, sticksCount) => {
    if (sticksCount <= 0) {
        return [];
    }
    const stickImages = new Array(sticksCount).fill(placeholderImage);
    return stickImages;
};
export const prepareInitialDynamicGallery = ({ bundleConfig, placeholdersArray, multipacksQuantities, elementsDynamicGalleryUrls, }) => {
    let initialGallery = [];
    initialGallery = placeholdersArray.map((item) => {
        const singleElement = bundleConfig[item.itemNumber - 1];
        const optionId = singleElement?.optionId;
        const sticksCount = getQtyForMultipack(multipacksQuantities, optionId);
        if (item.itemNumber < 1) {
            throw new Error(`Item number must be greater than or equal to 1 for item: ${JSON.stringify(item)}`);
        }
        if (typeof optionId !== "number") {
            throw new Error(`OptionId is not a valid number for item: ${JSON.stringify(item)}`);
        }
        const defaultProduct = singleElement.options.find((option) => option.isDefault);
        if (singleElement.type === "multi") {
            return {
                ...item,
                placeholderImage: fallbackSticksImages(item.placeholderImage, sticksCount),
                optionId,
                sicksPlaceHolderImage: item.placeholderImage,
            };
        }
        if (defaultProduct) {
            return {
                ...item,
                optionId,
                placeholderImage: elementsDynamicGalleryUrls[defaultProduct.id],
            };
        }
        return {
            ...item,
            optionId,
        };
    });
    return initialGallery;
};
const handleSticksImages = (selectedElement, sticksCount, elementsDynamicGalleryUrls, placeholderImage = "") => {
    const imageCollection = new Array(sticksCount).fill(placeholderImage);
    let selectedOptionsQuantity = 0;
    if (selectedElement.quantities && Array.isArray(selectedElement.quantities)) {
        selectedElement.quantities.forEach((item) => {
            const { selection_id, qty } = item;
            if (selection_id in elementsDynamicGalleryUrls) {
                const image = elementsDynamicGalleryUrls[selection_id];
                for (let i = 0; i < qty; i++) {
                    imageCollection[sticksCount - 1 - selectedOptionsQuantity] = image;
                    selectedOptionsQuantity++;
                }
            }
        });
    }
    return imageCollection;
};
export const retriveImageCollection = (selectedElement, multipacksQuantities, elementsDynamicGalleryUrls, imageCollection = []) => {
    const selectedOptionIdString = selectedElement.optionId.toString();
    const updatedImageCollection = imageCollection.map((item) => {
        const optionId = item.optionId.toString();
        const sticksCount = getQtyForMultipack(multipacksQuantities, item.optionId);
        if (selectedOptionIdString === optionId) {
            if (selectedElement.type === "multi") {
                return {
                    ...item,
                    placeholderImage: handleSticksImages(selectedElement, sticksCount, elementsDynamicGalleryUrls, item.sicksPlaceHolderImage),
                };
            }
            else if (selectedElement.productId && elementsDynamicGalleryUrls[selectedElement.productId]) {
                return {
                    ...item,
                    placeholderImage: elementsDynamicGalleryUrls[selectedElement.productId],
                };
            }
        }
        return item;
    });
    return updatedImageCollection;
};
//# sourceMappingURL=helpers.js.map